// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core from "@material-ui/core";
import * as App_Typography$DvmAdminFrontendFr from "../../../../common/App_Typography.bs.js";
import * as Order_Detail_Types_Comment$DvmAdminFrontendFr from "../Order_Detail_Types_Comment.bs.js";
import * as Order_Detail_Closed_Siret_Message$DvmAdminFrontendFr from "./Order_Detail_Closed_Siret_Message.bs.js";

function Order_Detail_Error_Comment(Props) {
  var comment = Props.comment;
  var order = Props.order;
  var tmp = {
    children: comment.messageId === /* SIRET_CLOSED */119 ? React.createElement(Order_Detail_Closed_Siret_Message$DvmAdminFrontendFr.make, {
            siret: order.body.orderSiret,
            comment: comment
          }) : Belt_Option.getWithDefault(comment.messageLabel, ""),
    variant: "caption"
  };
  var tmp$1 = comment.messageType === /* ERROR */1 ? "error" : undefined;
  if (tmp$1 !== undefined) {
    tmp.color = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement(Core.Grid, {
              children: React.createElement(App_Typography$DvmAdminFrontendFr.make, tmp),
              item: true,
              key: Order_Detail_Types_Comment$DvmAdminFrontendFr.toString(comment.messageId)
            });
}

var make = Order_Detail_Error_Comment;

export {
  make ,
}
/* react Not a pure module */
